import React, { lazy } from 'react';
export function MechanismSection() {
  return <section className="relative py-4 md:py-14 px-6 bg-white overflow-hidden" data-id="element-133">
      {/* Abstract biological background */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]" data-id="element-134">
        <svg className="w-full h-full" viewBox="0 0 800 1200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-135">
          {/* Neuron network */}
          <circle cx="120" cy="150" r="8" fill="#2D6A4F" data-id="element-136" />
          <circle cx="200" cy="100" r="6" fill="#2D6A4F" data-id="element-137" />
          <circle cx="80" cy="250" r="5" fill="#2D6A4F" data-id="element-138" />
          <circle cx="300" cy="180" r="7" fill="#2D6A4F" data-id="element-139" />
          <line x1="120" y1="150" x2="200" y2="100" stroke="#2D6A4F" strokeWidth="1.5" data-id="element-140" />
          <line x1="120" y1="150" x2="80" y2="250" stroke="#2D6A4F" strokeWidth="1.5" data-id="element-141" />
          <line x1="120" y1="150" x2="300" y2="180" stroke="#2D6A4F" strokeWidth="1.5" data-id="element-142" />
          <line x1="200" y1="100" x2="300" y2="180" stroke="#2D6A4F" strokeWidth="1" data-id="element-143" />

          {/* Cell structures */}
          <ellipse cx="650" cy="300" rx="60" ry="35" stroke="#1B263B" strokeWidth="2" data-id="element-144" />
          <ellipse cx="650" cy="300" rx="25" ry="15" stroke="#1B263B" strokeWidth="1.5" data-id="element-145" />
          <circle cx="680" cy="290" r="4" fill="#F4A261" data-id="element-146" />

          {/* Mitochondria */}
          <ellipse cx="100" cy="600" rx="40" ry="22" stroke="#2D6A4F" strokeWidth="2" data-id="element-147" />
          <path d="M70 600 Q85 585 100 600 Q115 615 130 600" stroke="#2D6A4F" strokeWidth="1.5" fill="none" data-id="element-148" />

          {/* ATP molecules */}
          <circle cx="700" cy="700" r="12" stroke="#F4A261" strokeWidth="1.5" fill="none" data-id="element-149" />
          <text x="692" y="705" fill="#F4A261" fontSize="8" fontWeight="bold" data-id="element-150">
            ATP
          </text>

          <circle cx="750" cy="650" r="10" stroke="#F4A261" strokeWidth="1" fill="none" data-id="element-151" />
          <text x="743" y="654" fill="#F4A261" fontSize="7" fontWeight="bold" data-id="element-152">
            ATP
          </text>

          {/* Energy waves */}
          <path d="M500 900 Q550 870 600 900 Q650 930 700 900" stroke="#F4A261" strokeWidth="1.5" fill="none" data-id="element-153" />
          <path d="M480 930 Q530 900 580 930 Q630 960 680 930" stroke="#F4A261" strokeWidth="1" fill="none" data-id="element-154" />

          {/* More neurons top right */}
          <circle cx="600" cy="80" r="6" fill="#2D6A4F" data-id="element-155" />
          <circle cx="700" cy="120" r="8" fill="#2D6A4F" data-id="element-156" />
          <circle cx="680" cy="50" r="5" fill="#2D6A4F" data-id="element-157" />
          <line x1="600" y1="80" x2="700" y2="120" stroke="#2D6A4F" strokeWidth="1" data-id="element-158" />
          <line x1="700" y1="120" x2="680" y2="50" stroke="#2D6A4F" strokeWidth="1" data-id="element-159" />
          <line x1="600" y1="80" x2="680" y2="50" stroke="#2D6A4F" strokeWidth="1" data-id="element-160" />

          {/* Cell bottom left */}
          <circle cx="200" cy="1000" r="45" stroke="#1B263B" strokeWidth="2" fill="none" data-id="element-161" />
          <circle cx="200" cy="1000" r="18" stroke="#1B263B" strokeWidth="1.5" fill="none" data-id="element-162" />
          <circle cx="210" cy="990" r="5" fill="#2D6A4F" opacity="0.5" data-id="element-163" />

          {/* DNA helix hint */}
          <path d="M400 400 Q420 380 440 400 Q460 420 480 400 Q500 380 520 400" stroke="#1B263B" strokeWidth="1.5" fill="none" data-id="element-164" />
          <path d="M400 410 Q420 430 440 410 Q460 390 480 410 Q500 430 520 410" stroke="#1B263B" strokeWidth="1.5" fill="none" data-id="element-165" />
        </svg>
      </div>

      <div className="relative max-w-5xl mx-auto" data-id="element-166">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-16" data-id="element-167">
          <span className="text-accent font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-168">
            La Solución
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-169">
            Presentamos: <br className="hidden md:block" data-id="element-170" />
            <span className="text-accent" data-id="element-171">El Envés del Metabolismo.</span>
          </h2>
          <p className="text-xl text-navy/70 max-w-2xl mx-auto" data-id="element-172">
            <strong className="text-navy" data-id="element-173">
              No es un protocolo de bienestar genérico.
            </strong>{' '}
            Es un manual de instrucciones para que tu cuerpo deje de usar{' '}
            <strong className="text-navy" data-id="element-174">"energía barata"</strong> y empiece a
            usar su{' '}
            <span className="text-accent font-semibold" data-id="element-175">
              fuente de reserva más poderosa
            </span>
            .
          </p>
        </div>

        {/* Product Presentation: iPad + Description */}
        <div className="grid md:grid-cols-5 gap-6 md:gap-10 items-center mb-10 md:mb-24" data-id="element-176">
          {/* iPad Image — 2 cols */}
          <div className="md:col-span-2 flex justify-center" data-id="element-177">
            <div className="relative" data-id="element-178">
              {/* Glow effect behind iPad */}
              <div className="absolute -inset-6 bg-amber/10 rounded-3xl blur-2xl" data-id="element-179"></div>
              <img src="https://cdn.magicpatterns.com/uploads/w3ev3TgxJHPu3Wne1dzKek/portada-fondo-transparente.png" alt="El Envés del Metabolismo — Protocolo de Reinicio Biológico mostrado en iPad" className="relative w-72 md:w-80 animate-subtle-pulse drop-shadow-2xl" loading="lazy" decoding="async" width={320} height={400} data-id="element-180" />
            </div>
          </div>

          {/* Description — 3 cols */}
          <div className="md:col-span-3" data-id="element-181">
            <h3 className="text-2xl font-bold text-navy mb-4 font-serif" data-id="element-182">
              ¿Qué es exactamente?
            </h3>
            <p className="text-lg text-navy/80 leading-relaxed mb-6" data-id="element-183">
              Este no es un consejo de salud convencional. Es un{' '}
              <strong className="text-navy" data-id="element-184">
                manual de instrucciones biológicas{' '}
              </strong>
              diseñado para que tu química interna deje de sabotear tu enfoque.
            </p>
            <p className="text-lg text-navy/80 leading-relaxed mb-6" data-id="element-185">
              Un sistema exacto para ser ejecutado en{' '}
              <strong className="text-navy" data-id="element-186">72 horas</strong> y recuperar la
              claridad mental que la productividad moderna te robó. Sin teorías
              abstractas, solo ingeniería biológica aplicada a tu rendimiento
              cognitivo.
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-187">
              <span className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-semibold" data-id="element-188">
                <span className="w-2 h-2 bg-accent rounded-full" data-id="element-189"></span>
                Sin niebla mental
              </span>
              <span className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-semibold" data-id="element-190">
                <span className="w-2 h-2 bg-accent rounded-full" data-id="element-191"></span>
                Energía sostenida
              </span>
              <span className="inline-flex items-center gap-2 bg-amber/10 text-amber px-4 py-2 rounded-full text-sm font-semibold" data-id="element-192">
                <span className="w-2 h-2 bg-amber rounded-full" data-id="element-193"></span>
                Reset en 72h
              </span>
            </div>
          </div>
        </div>

        {/* 3-Day Timeline */}
        <div className="relative" data-id="element-194">
          <h3 className="text-2xl md:text-3xl font-bold text-navy text-center mb-6 md:mb-12 font-serif" data-id="element-195">
            Tu reinicio en <span className="text-accent" data-id="element-196">3 días</span>
          </h3>

          {/* Timeline line */}
          <div className="absolute left-8 top-24 bottom-8 w-0.5 bg-accent/20 hidden md:block" data-id="element-197"></div>

          <div className="space-y-10" data-id="element-198">
            {/* Day 1 */}
            <div className="relative flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-199">
              <div className="flex-shrink-0 w-16 h-16 bg-navy text-amber rounded-2xl flex items-center justify-center font-serif text-2xl font-bold shadow-lg z-10" data-id="element-200">
                D1
              </div>
              <div className="bg-background p-8 rounded-2xl flex-1 border border-navy/5 shadow-sm" data-id="element-201">
                <h4 className="text-2xl font-bold text-navy mb-3" data-id="element-202">
                  Día 1: La Calibración
                </h4>
                <p className="text-lg text-navy/80" data-id="element-203">
                  La{' '}
                  <strong className="text-navy" data-id="element-204">
                    niebla mental empieza a disiparse
                  </strong>
                  . Notás que tu atención ya no salta de un lado a otro; el{' '}
                  <span className="text-accent font-semibold" data-id="element-205">
                    enfoque deja de ser un esfuerzo y empieza a ser una decisión
                    consciente
                  </span>
                  .
                </p>
              </div>
            </div>

            {/* Day 2 */}
            <div className="relative flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-206">
              <div className="flex-shrink-0 w-16 h-16 bg-navy text-amber rounded-2xl flex items-center justify-center font-serif text-2xl font-bold shadow-lg z-10" data-id="element-207">
                D2
              </div>
              <div className="bg-background p-8 rounded-2xl flex-1 border border-navy/5 shadow-sm" data-id="element-208">
                <h4 className="text-2xl font-bold text-navy mb-3" data-id="element-209">
                  Día 2: Flujo Sostenido
                </h4>
                <p className="text-lg text-navy/80" data-id="element-210">
                  Desaparece el{' '}
                  <strong className="text-navy" data-id="element-211">crash de media tarde</strong>.
                  Tu cerebro mantiene una{' '}
                  <span className="text-accent font-semibold" data-id="element-212">
                    energía estable que te permite llegar al final de tu jornada
                    con la misma lucidez con la que empezaste
                  </span>
                  .
                </p>
              </div>
            </div>

            {/* Day 3 */}
            <div className="relative flex flex-col md:flex-row gap-6 md:gap-10 items-start" data-id="element-213">
              <div className="flex-shrink-0 w-16 h-16 bg-accent text-white rounded-2xl flex items-center justify-center font-serif text-2xl font-bold shadow-lg z-10" data-id="element-214">
                D3
              </div>
              <div className="bg-accent/5 p-8 rounded-2xl flex-1 border border-accent/20 shadow-sm" data-id="element-215">
                <h4 className="text-2xl font-bold text-navy mb-3" data-id="element-216">
                  Día 3: Optimización Cognitiva
                </h4>
                <p className="text-lg text-navy/80" data-id="element-217">
                  Tu{' '}
                  <strong className="text-navy" data-id="element-218">
                    química interna se estabiliza
                  </strong>
                  . Notás una{' '}
                  <span className="text-accent font-semibold" data-id="element-219">
                    agudeza mental y una ligereza biológica que te devuelven la
                    capacidad de liderar y crear sin interferencias de fondo
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}